/*
  OBSI – <obsi-popup>
  Promo popup with triggers (delay / scroll % / exit-intent), frequency cap
  (localStorage), and an optional schedule. Always shows in the Theme Editor so
  it can be edited. Honors Escape / overlay / close button.
*/
if (!customElements.get('obsi-popup')) {
  customElements.define(
    'obsi-popup',
    class ObsiPopup extends HTMLElement {
      connectedCallback() {
        this.key = 'obsi-popup-' + (this.dataset.id || 'default');
        this.shown = false;
        this.designMode = !!(window.Shopify && window.Shopify.designMode);

        this.querySelectorAll('[data-popup-close]').forEach(
          function (el) { el.addEventListener('click', this.hide.bind(this)); }.bind(this)
        );
        document.addEventListener('keydown', this.onKey.bind(this));

        if (this.designMode) {
          var self = this;
          document.addEventListener('shopify:section:select', function (e) {
            if (e.detail && e.detail.sectionId === self.dataset.id) self.reveal();
          });
          document.addEventListener('shopify:section:deselect', function (e) {
            if (e.detail && e.detail.sectionId === self.dataset.id) self.hide();
          });
          return;
        }
        if (!this.withinSchedule()) return;
        if (this.suppressed()) return;
        this.armTriggers();
      }

      onKey(e) { if (e.key === 'Escape' && !this.hidden) this.hide(); }

      withinSchedule() {
        var now = Date.now();
        var s = this.dataset.start, e = this.dataset.end;
        if (s) { var st = new Date(s).getTime(); if (!isNaN(st) && now < st) return false; }
        if (e) { var et = new Date(e).getTime(); if (!isNaN(et) && now > et) return false; }
        return true;
      }

      suppressed() {
        try {
          var days = parseInt(this.dataset.frequency || '0', 10);
          if (!days) return false;
          var ts = parseFloat(localStorage.getItem(this.key) || '0');
          if (!ts) return false;
          return Date.now() - ts < days * 86400000;
        } catch (e) { return false; }
      }

      armTriggers() {
        var self = this;
        var delay = parseInt(this.dataset.delay || '0', 10);
        var scroll = parseInt(this.dataset.scroll || '0', 10);
        var exit = this.dataset.exit === 'true';

        if (delay > 0 || (!scroll && !exit)) {
          this.timer = setTimeout(function () { self.reveal(); }, Math.max(0, delay) * 1000);
        }
        if (scroll > 0) {
          this.onScroll = function () {
            var h = document.documentElement;
            var max = h.scrollHeight - h.clientHeight;
            var pct = max > 0 ? (h.scrollTop || document.body.scrollTop) / max * 100 : 0;
            if (pct >= scroll) self.reveal();
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
        if (exit) {
          this.onExit = function (e) { if (e.clientY <= 0) self.reveal(); };
          document.addEventListener('mouseout', this.onExit);
        }
      }

      cleanup() {
        clearTimeout(this.timer);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
        if (this.onExit) document.removeEventListener('mouseout', this.onExit);
      }

      reveal() {
        if (this.shown) return;
        this.shown = true;
        this.cleanup();
        this.hidden = false;
        document.body.classList.add('obsi-popup-open');
        if (!this.designMode) {
          try { localStorage.setItem(this.key, Date.now().toString()); } catch (e) {}
        }
        var focusable = this.querySelector('input, button, [href]');
        if (focusable) focusable.focus();
      }

      hide() {
        this.hidden = true;
        document.body.classList.remove('obsi-popup-open');
      }
    }
  );
}
